import $ = require('jquery');
import {ListWidgetService} from "../service.listwidgets";
import {WebSocket} from "../websocket";
import { Utility} from '../utility';
export class workzoneTypes {
    type: string;
    count: number;
    dist: string;
    isDistNum: boolean;
}

export default class workzonesController {
    static $inject = ["$scope", "$http", "ListWidgetService"];
    static AngularDependencies = ['$scope', '$http', 'ListWidgetService', workzonesController];

    private oldData: any;

    public WorkzoneTypes: workzoneTypes[] = [];
    public myOrder = ['type'];
    public districts: boolean = true;
    public types: string[] = ["CONSTRUCTION", "MAINTENANCE", "PAINT CREW", "UTILITY"];
    public utilityTotal = 0;
    public constructionTotal = 0;
    public maintenanceTotal = 0;
    public paintTotal = 0;

    public districtarray: string[] = ['1', '2', '3', '4', '5', '6'];

    public districtList = {
        district: ['1', '2', '3', '4', '5', '6'],
        CONSTRUCTION: [0, 0, 0, 0, 0, 0]
    };

    public workzones: any;
    public workzoneDistricts: any;
    
    public flipOrder(sort: string) {
        if (sort == "count") {
            if (this.myOrder[0] == "count") {
                this.myOrder = ["-count"];
            }
            else if (this.myOrder[0] == "-count") {
                this.myOrder = ["count"];
            }
            else {
                this.myOrder = ["-count"];
            }
        }
        else if (sort == "type") {
            if (this.myOrder[0] == "type") {
                this.myOrder = ["-type"];
            }
            else if (this.myOrder[0] == "-type") {
                this.myOrder = ["type"];
            }
            else {
                this.myOrder = ["type"];
            }
        }
    }

    public AddtoWorkzoneList(data) {
        this.workzones = data.WorkZone;
        this.workzoneDistricts = data.WorkZone_District;
        this.WorkzoneTypes = [];
        var districtValueInParam = Utility.getQueryVariable("district");
        for (let x = 0; x < this.workzones.length; x++) {
            this.WorkzoneTypes.push({
                type: this.workzones[x].workzone_descrip,
                count: this.workzones[x].workzone_count,
                dist: districtValueInParam,
                isDistNum: (Number(districtValueInParam) >= 1 && Number(districtValueInParam) <= 6) ? true : false
            })
        }
        for (let x = 0; x < this.workzoneDistricts.length; x++) {
            this.districtList.CONSTRUCTION[this.workzoneDistricts[x].workzone_district-1] = this.workzoneDistricts[x].workzone_count;
        }
        this.oldData = data.WorkZone;
        this.ListWidgetService.updatecount("Work Zones", this.WorkzoneTypes.length);
    }

    constructor($scope: ng.IScope, $http: angular.IHttpService, public ListWidgetService: ListWidgetService) {
        let vm = this;
        WebSocket.OnUpdate(function(data) {
            if(!Utility.deepEqual(vm.oldData,data.WorkZone)){
                vm.AddtoWorkzoneList(data);
                $scope.$digest();
                $scope.$broadcast("workzone_data_ready");
            }
        });

        vm.districts = false;

        this.districtList = {
            district: this.districtarray,
            CONSTRUCTION: [0, 0, 0, 0, 0, 0]
        }

        var acc = document.getElementsByClassName("topbar");
        var i;
        for (i = 0; i < acc.length; i++) {
            var test = <any>acc[i]
            test.onclick = function() {
                this.classList.toggle("active");
                this.nextElementSibling.children[0].classList.toggle("hide");
            }
        }

        $scope.$broadcast("workzone_data_ready");
    }
}




// WEBPACK FOOTER //
// ./src/app/workzones/controller.workzones.ts